import { useEffect, useState } from 'react';

/** Times on Home read in the viewer's own time zone (the browser's). */
const TIME = new Intl.DateTimeFormat(undefined, { hour: '2-digit', minute: '2-digit' });

export const timeOfDay = (iso: string) => TIME.format(new Date(iso));

/** "just now", "12 min ago", "3 h ago", else the date. */
export function ago(iso: string, now = Date.now()): string {
  const minutes = Math.floor((now - Date.parse(iso)) / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;
  if (minutes < 24 * 60) return `${Math.floor(minutes / 60)} h ago`;
  return new Date(iso).toLocaleDateString();
}

/** Midnight of `d`'s day, in the viewer's time zone. */
export function startOfDay(d: Date): Date {
  const out = new Date(d);
  out.setHours(0, 0, 0, 0);
  return out;
}

/** Calendar days later (or earlier), at the same local time: DST-safe, unlike adding 24 h. */
export function addDays(d: Date, days: number): Date {
  const out = new Date(d);
  out.setDate(out.getDate() + days);
  return out;
}

export const firstOfMonth = (d: Date) => new Date(d.getFullYear(), d.getMonth(), 1);

export const sameDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

/** The 42 days (6 weeks, Sunday first) a month's calendar shows, starting on or before the 1st. */
export function monthGrid(month: Date): Date[] {
  const first = firstOfMonth(month);
  const start = addDays(first, -first.getDay());
  return Array.from({ length: 42 }, (_, i) => addDays(start, i));
}

/** The current time, re-read every minute (the Calendar's "now" line). */
export function useNow(everyMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), everyMs);
    return () => clearInterval(t);
  }, [everyMs]);
  return now;
}
